import { render, staticRenderFns } from "./listaappuntamenti.vue?vue&type=template&id=f26bccf6"
import script from "./listaappuntamenti.vue?vue&type=script&lang=js"
export * from "./listaappuntamenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports